// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingBillingOptionItemResponse

export type WidgetBookingBillingOptionItemApiResponse = {
	total: number;
};

export type WidgetBookingBillingOptionItem = {
	total: number;
};

export function hydrateWidgetBookingBillingOptionItem(data: WidgetBookingBillingOptionItemApiResponse): WidgetBookingBillingOptionItem {
	return { ...data };
}